export type BundledUiAsset = string | Record<string, unknown>;

export const bundledUiAssets = new Map<string, BundledUiAsset>();
